import type { RouteObject } from "react-router";

import { NotLoggedInGuard } from "@/authentication/NotLoggedInGuard";
import { ErrorPage } from "@/components/Error/ErrorPage";

import { ForgotPasswordPage } from "./pages/ForgotPasswordPage";
import { LogoutPage } from "./pages/LogoutPage";
import { MagicLinkCallbackPage } from "./pages/MagicLinkCallbackPage";
import { MagicLinkEnterCodePage } from "./pages/MagicLinkEnterCodePage";
import { MagicLinkSentPage } from "./pages/MagicLinkSentPage";
import { MultiFactorAuthenticationPage } from "./pages/MultiFactorAuthenticationPage";
import { ResetPasswordPage } from "./pages/ResetPasswordPage";
import { SignInSignUpPage } from "./pages/SignInSignUpPage";
import { VerifyEmailPage } from "./pages/VerifyEmailPage";
import { authenticationRoutes } from "./routes";

export const authenticationRoute = [
  {
    path: authenticationRoutes.login,
    element: (
      <NotLoggedInGuard>
        <SignInSignUpPage />
      </NotLoggedInGuard>
    ),
  },
  {
    path: authenticationRoutes.logout,
    element: <LogoutPage />,
  },
  {
    path: authenticationRoutes.verifyEmail,
    element: <VerifyEmailPage />,
  },
  {
    path: authenticationRoutes.multiFactorAuthentication,
    element: (
      <NotLoggedInGuard>
        <MultiFactorAuthenticationPage />
      </NotLoggedInGuard>
    ),
  },
  {
    path: authenticationRoutes.forgotPassword,
    element: (
      <NotLoggedInGuard>
        <ForgotPasswordPage />
      </NotLoggedInGuard>
    ),
  },
  {
    path: authenticationRoutes.resetPassword,
    element: <ResetPasswordPage />,
  },
  {
    path: authenticationRoutes.magicLinkSent,
    element: <MagicLinkSentPage />,
  },
  {
    path: authenticationRoutes.magicLink,
    element: <MagicLinkCallbackPage />,
  },
  {
    path: authenticationRoutes.magicLinkEnterCode,
    element: <MagicLinkEnterCodePage />,
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
